import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MaintenanceReport } from '@/models/maintenance';
import { getPendingMaintenanceReports } from '@/services/maintenanceService';
import MaintenanceCard from './MaintenanceCard';
import { useData } from '@/contexts/DataContext';
import { Loader2 } from 'lucide-react';

const PendingMaintenanceList: React.FC = () => {
  const [pendingReports, setPendingReports] = useState<MaintenanceReport[]>([]);
  const [loading, setLoading] = useState(true);
  const { screens } = useData();

  // Cargar los reportes pendientes
  const loadPendingReports = async () => {
    setLoading(true);
    try {
      const reports = await getPendingMaintenanceReports();
      setPendingReports(reports);
    } catch (error) {
      console.error("Error al cargar reportes pendientes:", error);
    } finally {
      setLoading(false);
    }
  };

  // Cargar reportes al montar el componente y cuando cambian las pantallas
  useEffect(() => {
    loadPendingReports();
  }, [screens]);

  // Manejar cuando un reporte se marca como completado
  const handleReportCompleted = () => {
    loadPendingReports();
  };

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold">Tareas de Mantenimiento Pendientes</h2>
      
      {loading ? (
        <Card>
          <CardContent className="py-6 flex justify-center items-center">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <span className="ml-2">Cargando tareas pendientes...</span>
          </CardContent>
        </Card>
      ) : pendingReports.length === 0 ? (
        <Card>
          <CardContent className="py-6">
            <p className="text-center text-muted-foreground">
              No hay tareas de mantenimiento pendientes
            </p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {pendingReports.map(report => (
            <MaintenanceCard 
              key={report.id} 
              report={report} 
              onComplete={handleReportCompleted} 
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PendingMaintenanceList; 